/**
 @ngdoc directive
 @name defaultSearchTerms

 @description
 Section that loads and holds default search terms in advanced search

 @usage
 <default-search-terms search-terms-data="JSON PRING"></default-search-terms>


 @param {search-terms-data}  json PRINT                       - Data for all default search terms

 */

(function() {
    'use strict';
    var defaultSearchTerms = function ($templateCache, $http, ajaxCall,i18nService, xmsNotificationFactory, orderByFilter) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                formModel: "=",
                editstate: "=",
                searchTermsData: "@",
                lookupUrl: "@",
                additionLDefaultSearchTerm: "@",
                sortableOptions: "@",
                defaultSearchEditable: "=",
                editDefaultSearchPreference:"=",
                configscreen: "=",
                objectType: "@",
                isOrgDefault: "="
            },
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/defaultSearchTerms.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                _this.debug = false; // TODO: Remember to set this to false
                var temporarySearchTerms = [];

                // Mobile device detection
                _this.mobile = cssua.ua.mobile ? true : false;

                this.$onInit = function(){

                    _this.i18nService = i18nService.preLoadI18nValues({
                        'personalised.search.label': 'Personalised Search',
                        'personalised.search.customise.label': 'Customise',
                        'personalised.search.heading.tooltip' : 'Your frequently used search criteria will be displayed here',
                        'personalised.search.searchTerms.tooltip' : 'Click into the box to add additional search terms to your Personalised search',
                        'personalised.search.customise.tooltip' : 'Add or remove frequently used search terms to your personalised search',
                        'personalised.search.save.customisations.label':'Save Customisations',
                        'personalised.search.save.values.label':'Save Values',
                        'personalised.search.add.searchTerms.label':'Add Personalised Search Terms'
                        /** 'personalised.search.restore.orgs.label':'Restore Org’s Default'
                         * 'personalised.search.restore.label'::Restoring to Org Default will erase your
                         * personalised search and replace with the org default search
                         **/
                    });


                    // Drag and drop plugin settings http://api.jqueryui.com/sortable/
                    _this.sortableOptions = {
                        disabled: true,
                        tolerance: "pointer",
                        cursor: "move",
                        revert: true,
                        helper: "clone",
                        cursorAt: { left: 5, top: 5 }
                    };
                    //Required to initialize tooltips
                    $('[data-toggle="tooltip"]').tooltip();

                    // Parsing default search terms data as JSON
                    _this.searchTerms = JSON.parse(_this.searchTermsData);
                    _this.copyOfsearchTerms = JSON.parse(_this.searchTermsData);
                };

                // Getting list of all available default search terms
                $scope.getAdditionalDefaultSearchTerms = function(){
                    _this.additionalDefaultSearchTerms = [];
                    var url = WEBAPP_PATH + '/advancedSearch/getAvailableSearchFields?xmsType=' + _this.objectType;
                    $http({
                        method: 'GET',
                        url: url
                    }).then(function successCallback(response) {
                        _this.additionalDefaultSearchTerms = response.data;
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                    }, function errorCallback(response) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });
                };

                // Restoring Organisation Default Search Terms
                $scope.restoreToOrgDefault = function(){
                    var url = WEBAPP_PATH + '/defaultSearchField/restoreDefaultSearchFields/' + _this.objectType;
                    $http({
                        method: 'POST',
                        url: url
                    }).then(function successCallback(response) {
                        _this.isOrgDefault = true;
                        $scope.getSearchFieldsAndTheirValues(false); //Never an admin page
                        xmsNotificationFactory.addObj({id: "defaultSearchTermsRestoring", type: "success", bodyHtml: "Organisation Default Search Terms Restored", timeout:10});
                    }, function errorCallback(response) {
                        xmsNotificationFactory.addObj({id: "defaultSearchTermsRestoring", type: "danger", bodyHtml: 'Error restoring default search terms', timeout:10});
                    });
                };

                // Edit state enabling function
                $scope.editState = function(){

                    // Creating temporary collection of existing search terms for cancel save function
                    temporarySearchTerms = [];
                    for(i in _this.searchTerms){
                        temporarySearchTerms.push(_this.searchTerms[i]);
                    }
                    if(!_this.mobile){
                        _this.sortableOptions = {
                            disabled: false
                        };
                    }
                    _this.editstate = true;

                };

                // Saving user modified default search terms
                $scope.saveDefaultSearchTerms = function(){

                    // Ordering search terms
                    var order = 0;
                    for(i in _this.searchTerms){
                        _this.searchTerms[i].order = order;
                        order++;
                    }

                    // Posting user defined default search terms
                    var ajaxUrl = WEBAPP_PATH + "/advancedSearch/saveDefaultSearchFields";
                    var data = {
                        xmsType: _this.objectType,
                        defaultSearchFields : _this.searchTerms,
                        isOrg: _this.configscreen
                    };

                    // TODO: Work on notification messages being passed after data receiving and submission
                    ajaxCall.getData(ajaxUrl, data).then(
                        function(response){
                            if (response.data.isLink) {
                                $window.location.href=response.data.link;
                            }
                            else if (response.data.error){
                                xmsNotificationFactory.addObj({id: "defaultSearchTermsSaving", type: "danger", bodyHtml: response.data, timeout:10});
                            }
                            else{
                                var searchFieldUserDefaultIdList = response.data.searchFieldUserDefaultIdList;
                                // update directive with new Search Field ids
                                angular.forEach(_this.searchTerms, function(obj, index){
                                    obj['searchFieldUserDefaultId'] = searchFieldUserDefaultIdList[index];
                                });
                                _this.isOrgDefault = false;
                                if(_this.searchTerms.length === 0){
                                    xmsNotificationFactory.addObj({id: "defaultSearchTermsEmpty", type: "warning", bodyHtml: "Saved Personalised Search was empty - Search Terms will revert to Org Default next time you visit this page", timeout:10});
                                }else{
                                    xmsNotificationFactory.addObj({id: "defaultSearchTermsSaving", type: "success", bodyHtml: "Default Search Terms Saved", timeout:10});
                                }
                            }
                        },
                        function(response) {
                            xmsNotificationFactory.addObj({id: "defaultSearchTermsSaving", type: "danger", bodyHtml: 'Error saving default search terms', timeout:10});
                        }
                    );

                    _this.editstate = false;
                    _this.sortableOptions = {
                        disabled: true
                    };
                };

                // Cancel editing default search terms
                $scope.cancelEditingSearchTerms = function(){
                    _this.searchTerms = temporarySearchTerms;
                    _this.editstate = false;
                    _this.sortableOptions = {
                        disabled: true
                    };
                };

                // Remove a search term
                $scope.removeDefaultSearchTerm = function(id){
                    for(var i in _this.searchTerms){
                        if(_this.searchTerms[i].id === id){
                            _this.searchTerms.splice(i, 1);
                        }
                    }
                    clearAddingDefaultSearchTermInput();
                };

                // Add a search term
                $scope.addDefaultSearchTerm = function($item){
                    _this.searchTerms.push($item);
                    clearAddingDefaultSearchTermInput();
                };

                // Closes the dropdown of available search terms
                function clearAddingDefaultSearchTermInput(){
                    _this.additionLDefaultSearchTerm = '';
                    //TODO: throws error, did not find any better way of removing focus from dropdown list yet
                    document.blur();
                    document.activeElement.blur();
                }

                $scope.searchTermsCount = function(){
                    if($scope.formModel.defaultSearchTerms == null){
                        return 0;
                    }
                    return Object.keys($scope.formModel.defaultSearchTerms).length || 0;
                };

                /**
                 * Load a fresh copy of the new data
                 * @param orgOnly  - Denotes is the page is administration page or not
                 */
                $scope.getSearchFieldsAndTheirValues = function(orgOnly){
                    var url = WEBAPP_PATH + '/defaultSearchField/getSearchFieldsAndTheirValues/'+_this.objectType+'?orgOnly='+orgOnly;
                    $http({
                        method: 'GET',
                        url: url
                    }).then(function successCallback(response) {
                        _this.searchTerms = response.data;
                        // $scope.form.$setPristine(); Not sure if I need this
                        //_this.isOrgDefault = true; Not sure if I need this
                    }, function errorCallback(response) {
                        xmsNotificationFactory.addObj({
                            id: "defaultSearchTermsRestoring", type: "danger", bodyHtml: 'Unable to refresh', timeout:10
                        });
                    });
                };

                $scope.saveValues = function(){
                    xmsNotificationFactory.add('saveValues', 'info', 'Saving Values', 5);
                    var ajaxUrl = WEBAPP_PATH + '/advancedSearch/saveDefaultSearchValues';
                    var data = {
                        xmsType: _this.objectType,
                        defaultSearchTerms: angular.toJson(_this.searchTerms),
                        defaultSearchValues: $scope.formModel.defaultSearchTerms,
                        isOrg: _this.configscreen,
                        isOrgDefault: _this.isOrgDefault
                    };

                    ajaxCall.getData(ajaxUrl, data).then(
                        function(response){
                            xmsNotificationFactory.add('saveValuesSuccess', 'success', 'Values Saved', 5);
                            $scope.form.$setPristine();
                            if(_this.isOrgDefault){
                                var searchFieldUserDefaultIdList = response.data.searchFieldUserDefaultIdList;
                                // update directive with new Search Field ids
                                angular.forEach(_this.searchTerms, function(obj, index){
                                    obj['searchFieldUserDefaultId'] = searchFieldUserDefaultIdList[index];
                                });
                            }
                            _this.isOrgDefault = false;
                        },
                        function(result) {
                            var errorMessage = "Error: " + result.status + ' -  failed to save values';
                            xmsNotificationFactory.add('saveValuesError', 'danger', errorMessage, 5);
                        });
                };
            }]
        };
    };

    defaultSearchTerms.$inject = ['$templateCache', '$http', 'ajaxCall', 'i18nService','xmsNotificationFactory', 'orderByFilter'];
    angular.module('app').directive('defaultSearchTerms', defaultSearchTerms);

}());